<template>
    <aside id="contact-list-sidebar">
        <newcontactsidebar></newcontactsidebar>
    </aside>
</template>
<script>

// Components
import NewContactsSidebar    from './NewContactsSidebar.vue';

export default {
    components: {
        'newcontactsidebar': NewContactsSidebar
    }
};
</script>
